import React from 'react';

export const ControlHubIcon: React.FC = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="3" width="12" height="4" rx="2" stroke="currentColor" />
    <circle cx="3.91287" cy="4.99978" r="0.912871" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9.5C1.89543 9.5 1 10.3954 1 11.5C1 12.6046 1.89543 13.5 3 13.5H12C13.1046 13.5 14 12.6046 14 11.5C14 10.3954 13.1046 9.5 12 9.5H3ZM11.25 12.618C11.8675 12.618 12.368 12.1175 12.368 11.5C12.368 10.8825 11.8675 10.382 11.25 10.382C10.6325 10.382 10.132 10.8825 10.132 11.5C10.132 12.1175 10.6325 12.618 11.25 12.618Z"
      fill="currentColor"
    />
  </svg>
);
